import { match } from 'ts-pattern'

import { DataAttribute } from '@frame/types'

import { FormValues, PayUnit } from './types'

export function getErrorLabelForKey(key: keyof FormValues, payUnit: PayUnit): string {
  return match(key)
    .with('current_gross_base_pay', () => {
      return match(payUnit)
        .with(PayUnit.ANNUALLY, PayUnit.OTHER, () => 'Annual Pay')
        .with(PayUnit.HOURLY, () => 'Hourly Pay')
        .exhaustive()
    })
    .with('start_date', () => 'Start Date')
    .with('end_date', () => 'End Date')
    .with('job_title', () => 'Position or Job Title')
    .with('employer_name', () => 'Employer Name')
    .with('employer_address', () => 'Employer Address')
    .with('hours_worked_per_week', () => 'Weekly Hours')
    .with('current_job', () => 'Current Job')
    .with('does_not_have_employer_address', () => 'Employer Address')
    .with('pay_unit', () => 'Pay Type')
    .exhaustive()
}

export function getLabelForPayType(payUnit: PayUnit): string {
  return match(payUnit)
    .with(PayUnit.ANNUALLY, () => 'Salary')
    .with(PayUnit.HOURLY, () => 'Hourly')
    .with(PayUnit.OTHER, () => 'Other')
    .exhaustive()
}

export function getDataCyForPayType(payUnit: PayUnit): string {
  return match(payUnit)
    .with(PayUnit.ANNUALLY, () => DataAttribute.PAY_UNIT_ANNUALLY)
    .with(PayUnit.HOURLY, () => DataAttribute.PAY_UNIT_HOURLY)
    .with(PayUnit.OTHER, () => DataAttribute.PAY_UNIT_OTHER)
    .exhaustive()
}
